import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { startCase } from 'lodash';
import './styles.css';

class ApplianceCloudSelect extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpened: false, currentSelected: props.currentSelected || 'appliance'  };
    this.toggleOpened = this.toggleOpened.bind(this);
    this.selectCurrent = this.selectCurrent.bind(this);
  }

  UNSAFE_componentWillReceiveProps({ currentSelected }) {
    if (this.props.currentSelected || currentSelected) {
      this.setState({ currentSelected });
    }
  }

  toggleOpened() {
    this.setState({ isOpened: !this.state.isOpened });
  }

  selectCurrent(currentValue) {
    const { handleSelected } = this.props;

    return () => {
      this.setState({ currentSelected: currentValue });
      handleSelected(currentValue);
    };
  }

  render() {
    const { isOpened, currentSelected } = this.state;

    return (
      <div
        className={classNames('appliance-cloud-select', {
          'is-opened': isOpened
        })}
      >
        <strong className="appliance-cloud-select-label">
          Consumption details for
        </strong>
        <div className="appliance-cloud-select-box" onClick={this.toggleOpened}>
          <div className="appliance-cloud-select-current">
            <div
              className={`appliance-cloud-select-square appliance-cloud-select-square-${currentSelected}`}
            />
            <span className="appliance-cloud-select-value">
              {currentSelected === 'appliance' ? 'Private Cloud' : 'Public Cloud'}
            </span>
            <span className="appliance-cloud-select-icon icon-budicon-460" />
          </div>
          <ul className="appliance-cloud-select-list">
            {currentSelected !== 'appliance' &&
              <li onClick={this.selectCurrent('appliance')}>
                <div className="appliance-cloud-select-square appliance-cloud-select-square-appliance" />
                <span>Private Cloud</span>
              </li>}
            {currentSelected !== 'cloud' &&
              <li onClick={this.selectCurrent('cloud')}>
                <div className="appliance-cloud-select-square appliance-cloud-select-square-cloud" />
                <span>Public Cloud</span>
              </li>}
          </ul>
        </div>
      </div>
    );
  }
}

ApplianceCloudSelect.propTypes = {
  handleSelected: PropTypes.func,
  currentSelected: PropTypes.string
};

export default ApplianceCloudSelect;
